import "./src/styles/all.scss";
import "@fastly/performance-observer-polyfill/polyfill";
import "katex/dist/katex.min.css";
// polyfill
require("intersection-observer");
